<template>
  <div class="RscOutInfo">
    <!-- Rsc 出库单 -->
    <div class="line_num">
      <span>行数 </span>
      <input type="text" :value="all_data.length" v-if="type === 'true'" />
    </div>
    <div style="display: flex" v-if="type === 'true'">
      <van-button type="info" size="small" style="display: flex; margin-right: 1rem" :text="ray"
        @click="holdRay()"></van-button>
      <div>
        <input id="scanQRCode" ref="getIDInpot" @keyup.enter="add_mx()" v-model="add_data" readonly
          style="height: 20px; width: 96px" autocomplete="off" @blur="hideMessage()" />
      </div>
    </div>

    <!-- 出库的数据 -->
    <div :style="style">
      <div class="goods-info-two" v-for="(i, index) in all_data" :key="index">
        <div style="width: 100%; text-align: right">
          <van-icon name="cross" @click="deleteData(index)" style="margin: 5px 5px 5px 0" />
        </div>
        <div class="info-order-h">
          <div style="width: 50%; display: flex; align-items: center">
            <div class="right-twenty">货号</div>
            <div class="data-order">{{ i.goods_number || i.number }}</div>
          </div>
          <div style="width: 50%; display: flex; align-items: center">
            <div class="right-twenty">产品名称</div>
            <div class="data-order">{{ i.goods_name || i.name }}</div>
          </div>
        </div>
        <div class="info-order-h">
          <div style="width: 50%; display: flex; align-items: center">
            <div class="right-twenty">供应商型号</div>
            <div class="data-order">{{ i.supplier_xh }}</div>
          </div>
          <div style="width: 50%; display: flex; align-items: center">
            <div class="right-twenty">明细码</div>
            <div class="data-order">{{ getnumber(i.gck_number) }}</div>
          </div>
        </div>
        <div class="sp-db-h">
          <div class="right-twenty">规格</div>
          <div class="data-order">{{ i.goods_normtype || i.size }}</div>
        </div>
        <div class="info-order-h">
          <div style="width: 50%; display: flex">
            <div class="right-twenty">卷号</div>
            <div class="data-order">{{ i.reel }}</div>
          </div>
          <div style="width: 50%; display: flex">
            <div class="right-twenty">卷号描述</div>
            <div class="data-order">{{ i.reel_detail }}</div>
          </div>
        </div>
        <div class="info-order-h">
          <div style="width: 50%; display: flex">
            <div class="right-twenty">数量</div>
            <div class="data-order">
              <input v-if="type === 'true'" v-model="i.goods_count" v-on:blur="countAll()" style="width: 2rem" />
              <span v-else>{{ i.goods_count }}</span>
            </div>
          </div>
          <div style="width: 50%; display: flex">
            <div class="right-twenty">计量单位</div>
            <div class="data-order">{{ i.unit }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="filling-goods-bottom">
      <van-button type="warning" class="bottom-button" @click="go_index()">
        回首页
      </van-button>
      <van-button type="info" v-if="type === 'true' && outNumber === '未出库'" @click="outInfo" class="bottom-button">
        确认出库
      </van-button>
      <van-button type="warning" @click="reload()">新建</van-button>
    </div>
  </div>
</template>

<script>
import { get, post } from "@/utils/request";
import { Dialog } from "vant";
import { Toast } from "vant";
export default {
  name: "RscOutinfo",
  data() {
    return {
      lineNum: 0,
      type: "true",
      ray: "已暂停，点击我继续扫码",
      all_data: [],
      add_data: "",
      style: "",
      outNumber: "未出库",
      allStatus: 1,
      getnumber: (i) => {
        if (i.indexOf("-") === -1) {
          return i;
        } else {
          return i.substr(0, i.indexOf("-"));
        }
      },
    };
  },
  mounted() {
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.style =
      "text-align: left;width: 100%;height: " + h * 0.78 + "px;overflow:scroll";

    this.holdRay();
  },
  methods: {
    go_index() {
      //回到首页
      Dialog.confirm({
        message: "确定要回首页吗？",
      })
        .then(() => {
          this.$router.push("/home");
        })
        .catch(() => {
          // on cancel
        });
    },
    outInfo() {
      // 出库的方法
      Dialog.confirm({
        message: "确认要出库吗?",
      }).then(async () => {
        let data = {
          number: "",
          num: "",
          size: "",
          name: "",
          gck_number: "",
          unit: "",
          aonumber:"",
          belong:"",
          goods:""
        };
        this.all_data.map((i) => {
          data.number += (i.goods_number || i.number) + ",";
          data.num += i.goods_count + ",";
          data.aonumber = i.aonumber + ',';
          data.belong = i.belong+',';
          data.goods = i.goods+','
          data.name += (i.goods_name || i.name) + ",";
          data.size += (i.goods_normtype || i.size) + "|";
          data.gck_number += i.gck_number + ",";
          data.unit += (i.unit || "") + ",";
        });
        for (let i in data) {
          data[i] = data[i].substring(0, data[i].length - 1);
        }
        data.type = this.allStatus
        let packing = await post(this.APIOBJ.doRcsout, data);
        if (packing.data.data.type == '1') {
          Dialog.confirm({
            message: packing.data.msg
          }).then(async () => {
            data.type = this.allStatus = 2;
            let packing = await post(this.APIOBJ.doRcsout, data);
            Toast(packing.data.msg);
            if (packing.data.msg.indexOf("成功") !== -1) {
              this.outNumber = "出库成功";
            }
            this.type = "";
          }).catch()
        } else {
          Toast(packing.data.msg);
          if (packing.data.msg.indexOf("成功") !== -1) {
            this.outNumber = "出库成功";
          }
          this.type = "";
        }
      });
    },
    holdRay() {
      this.ray = "扫描中";
      // 扫描 ing...
      let input = this.$refs.getIDInpot;
      input.focus();
      input.setAttribute("readonly", "readonly");
      input.removeAttribute("readonly");
    },
    add_mx() {
      // 扫描出数据
      // add_data 是数据
      if (this.add_data.indexOf("-") !== -1) {
        this.add_data = this.add_data.split("-")[0];
      }
      get(this.APIOBJ.outRcs, { gck_number: this.add_data }).then((res) => {
        if (res.data.status === 0) {
          Toast(res.data.msg);
        } else {
          let number = this.all_data.map((item) => item.gck_number);
          let index = number.indexOf(this.add_data);
          res.data.data.goods_count = res.data.data.goods_count
            ? res.data.data.goods_count
            : res.data.data.num;
          if (index !== -1) {
            this.all_data[index].goods_count =
              this.all_data[index].goods_count * 1 +
              res.data.data.goods_count * 1;
          } else {
            // 用三元表达式 来决定是否是售后还是订单的明细码的数量
            this.all_data.unshift(res.data.data);
          }

          Toast("添加成功");
        }
        this.add_data = "";
      });
    },
    hideMessage() {
      this.ray = "已暂停，点击我继续扫码";
      let input = this.$refs.getIDInpot;
      input.setAttribute("readonly", "readonly");
    },
    deleteData(i) {
      Dialog.confirm({
        message: "确定要删除当前出库单吗?",
      }).then(() => {
        if (this.type === "true") {
          let data = this.all_data[i];
          let gck_number = data.gck_number;
          let index = this.all_data.indexOf(gck_number);
          this.all_data.splice(index, 1);
          // this.w_data.splice(i, 1);
        } else {
          Toast("已入库,不能删除");
        }
      });
    },
    reload() {
      window.location.reload();
    },
  },
};
</script>

<style>
.line_num {
  text-align: left;
  padding-bottom: 1rem;
  padding-top: 0.5rem;
}

.filling-goods-bottom {
  display: flex;
  position: absolute;
  bottom: 0;
  width: 100%;
  margin-left: -10px;
}

.goods-info-two {
  margin-top: 10px;
  background-color: #f2f2f2;
  padding-bottom: 10px;
}

.info-order-h {
  width: 100%;
  display: flex;
  padding-top: 5px;
}

.order-info-input {
  border-radius: 5px;
  border: 1px solid #444444;
  text-align: center;
  width: 4.5rem;
}

.info-order-data {
  width: 65%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info-order-title {
  width: 35%;
}
</style>